import { Tooltip } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '~/components/DataGridCustom';

export type ObjectCellValue = Union.Nullable<Record<string, any>>;

interface ObjectCellProps<R extends GridValidRowModel = any> {
  value: ObjectCellValue;
  row: R;
}

export const ObjectCell = <R extends GridValidRowModel = any>({ value }: ObjectCellProps<R>) => {
  if (!value) return <>{NULLISH_CELL_VALUE}</>;

  const valueString = JSON.stringify(value, null, 2);
  const keys = Object.keys(value);
  const summary = keys.length > 2 ? `{ ${keys.slice(0, 2).join(', ')}... }` : `{ ${keys.join(', ')} }`;

  return (
    <Tooltip title={<pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{valueString}</pre>}>
      <span>{summary}</span>
    </Tooltip>
  );
};
